//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SectionEventComments",
  components: {
    SectionComments: () => import("@/components/common/SectionComments"),
  },
  computed: {
    ...mapGetters({
      id: "event/id",
      entity: "event/entity"
    })
  }
};
